import { render, staticRenderFns } from "./class-material.vue?vue&type=template&id=e0c420b6&scoped=true&"
import script from "./class-material.vue?vue&type=script&lang=ts&"
export * from "./class-material.vue?vue&type=script&lang=ts&"
import style0 from "./class-material.vue?vue&type=style&index=0&id=e0c420b6&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c420b6",
  null
  
)

export default component.exports